<app-reports
  title="Referral Match Verification Audit Reports"
  [filtersForm]="filtersForm"
  [reportsUrl]="reportsUrl"
  [reportsCountUrl]="reportsCountUrl"
  [validateForm]="validateForm"
  formMessage="Client or verification date required">

  <ng-template appNewReportOptionsTemplate let-filtersForm="filtersForm">
    <ng-container [formGroup]="filtersForm">

      <app-report-client-option
        formControlName="clientIds"
        [clientFilters]="{ applicableToReferralClaims: true }" />

      <app-report-date-range-option
        label="Verification Date"
        formControlName="verifiedDate" />

      <app-report-boolean-option
        label="High Value"
        formControlName="highValue" />

    </ng-container>
  </ng-template>

  <ng-template appReportDetailsTemplate let-report="report">

    <app-report-applied-client-option
      [options]="report.filters"
      [optionAssociations]="report.filterAssociations" />

    <app-report-applied-date-range-option
      [options]="report.filters"
      name="verifiedDate"
      label="Verification Date" />

    <app-report-applied-boolean-option
      [options]="report.filters"
      name="highValue"
      label="High Value" />

  </ng-template>

</app-reports>
